export enum InvoiceStatus {
    WaitingForInvoiceOrApproval = 'waitingForInvoiceOrApproval',
    NotPaidYet = 'notPaidYet',
    InvoicePaid = 'invoicePaid',
}
